module.exports = __webpack_public_path__ + "img/logotyp_z_bialym_napisem_z_datami.7b87b980.png";